import { useEffect, useState } from "react";
import Slider from "react-slick";

const BrandSectionOne = () => {
  const [isMobile, setIsMobile] = useState(false);

  const iconsList = [
    "/assets/images/icons/banner_logo_1.svg",
    "/assets/images/icons/banner_logo_2.svg",
    "/assets/images/icons/banner_logo_3.svg",
    "/assets/images/icons/banner_logo_4.svg",
    "/assets/images/icons/banner_logo_5.svg",
    "/assets/images/icons/banner_logo_6.svg",
    "/assets/images/icons/banner_logo_7.svg",
  ];

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <div className="brand section-bg">
      <div className={isMobile ? "" : "container container-three"}>
        <div className="brand-slider">
          <Slider {...settings}>
            {iconsList.map((icon, index) => (
              <div
                className="brand-items d-flex align-items-center justify-content-center"
                key={index}
              >
                <img
                  src={icon}
                  alt=""
                  className={`${index !== 1 ? "brand-item" : ""}`}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BrandSectionOne;

